<template>
    <v-app id="app">
        <Navigation/>
        <div>
            <router-view/>
        </div>
        <Footer/>
    </v-app>
</template>

<script>
    import Navigation from '@/components/Navigation'
    import Footer from '@/components/Footer'
    export default {
        name: 'ECH',
        components: {
            Navigation,
            Footer
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: "Muli", 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-overflow-scrolling: touch;
        background-color: white;
        @media screen and (min-width: 1200px) {
            .wrapper {
                max-width: 1200px;
                width: 100%;
                padding: 0 30px;
                margin: 0 auto;
                -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
                -moz-box-sizing: border-box; /* Firefox */
                box-sizing: border-box;
            }
        }


        a {
            cursor: pointer;
        }

        @font-face {
            font-family: "LibreBaskerville Bold";
            src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf")
        }

        @font-face {
            font-family: "LibreBaskerville Italic";
            src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Italic.ttf")
        }

        @font-face {
            font-family: "LibreBaskerville";
            src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Regular.ttf")
        }

        @font-face {
            font-family: "Tahu";
            src: url("https://elitecrafthomes.com/static_files/fonts/Tahu.ttf"),
            url("https://elitecrafthomes.com/static_files/fonts/Tahu.otf") format('opentype');
        }
    }
</style>



// WEBPACK FOOTER //
// src/ECH.vue